import React from 'react';
import Type from 'prop-types';
import { Formik, Form } from 'formik';
import cn from 'classnames';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';
import { ru } from 'locale';
import useStyles from './FormDialog.styles';

const FormDialog = props => {
  const {
    children,
    initialValues,
    validationSchema,
    title,
    description,
    cancelButtonText,
    submitButtonText,
    noPadding,
    open,
    onClose,
    onSubmit,
    ...other
  } = props;
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title" {...other}>
      {title && <DialogTitle id="form-dialog-title">{title}</DialogTitle>}
      <DialogContent
        className={cn({
          [classes.content]: noPadding,
        })}
      >
        {description && <DialogContentText>{description}</DialogContentText>}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {formikBag => (
            <Form className={classes.form} noValidate>
              {children(formikBag)}

              <DialogActions>
                <Button onClick={onClose} color="primary">
                  {cancelButtonText}
                </Button>
                <Button type="submit" color="primary">
                  {submitButtonText}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

FormDialog.propTypes = {
  open: Type.bool.isRequired,
  title: Type.string,
  description: Type.string,
  children: Type.func.isRequired,
  noPadding: Type.bool,
  validationSchema: Type.any, // eslint-disable-line react/forbid-prop-types
  initialValues: Type.object.isRequired, // eslint-disable-line react/forbid-prop-types
  cancelButtonText: Type.string,
  submitButtonText: Type.string,
  onClose: Type.func.isRequired,
  onSubmit: Type.func.isRequired,
};

FormDialog.defaultProps = {
  title: '',
  description: '',
  noPadding: 'false',
  cancelButtonText: ru.cancel,
  submitButtonText: ru.save,
  validationSchema: undefined,
};

export default FormDialog;
